export enum RefreshCadence {
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
    DAILY = "DAILY",
    HOURLY = "HOURLY",
    ON_DEMAND = "ON_DEMAND",
    WEEKLY = "WEEKLY",
}
